'use client'

import React, { createContext, use } from 'react'
import {
	SEEDED_DESKTOP_HEIGHT,
	SEEDED_DESKTOP_WIDTH,
	SEEDED_MOBILE_HEIGHT,
	SEEDED_MOBILE_WIDTH
} from '@/utils/detect-mobile'

const ViewportSeedContext = createContext<{ width: number; height: number } | null>(null)

/// Server passes the request's mobile hint. Client hooks read it as their
/// server snapshot so hydration matches the HTML, then `useWindowSize`
/// corrects to the real viewport after paint.
export function ViewportSeed({
	mobile,
	width,
	height,
	children
}: {
	mobile: boolean
	width?: number
	height?: number
	children: React.ReactNode
}) {
	const value = React.useMemo(
		() => ({
			width: width ?? (mobile ? SEEDED_MOBILE_WIDTH : SEEDED_DESKTOP_WIDTH),
			height: height ?? (mobile ? SEEDED_MOBILE_HEIGHT : SEEDED_DESKTOP_HEIGHT)
		}),
		[mobile, width, height]
	)
	return <ViewportSeedContext.Provider value={value}>{children}</ViewportSeedContext.Provider>
}

export function useViewportSeed() {
	return use(ViewportSeedContext)
}
